<ng-container *transloco="let t">
    <div
        fxLayout="column"
        fxLayoutAlign="start space-around"
        class="container"
        fxFlex="940px"
        fxFlex.sm="90%"
        fxFlex.xs="90%"
        fxFlexFill
    >
        <div fxLayout="row wrap" fxLayoutAlign="center">
            <div
                fxFlex="940px"
                fxLayout.xs="column"
                fxLayoutAlign="space-between center"
                fxFlex.xs="90%"
                fxFlex.sm="100"
                fxFlexFill
            >
                <h2>{{ t("support.privacy-policy.title") }}</h2>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="goBack()"
                    class="go-back"
                >
                    <mat-icon aria-hidden="false" aria-label="Go Back"
                        >arrow_back</mat-icon
                    >
                    {{ t("shared.go-back") | uppercase }}
                </button>
            </div>
            <div
                fxFlex="940px"
                fxLayoutAlign="start center"
                fxFlex.xs="90%"
                fxFlex.sm="100"
            ></div>
        </div>

        <mat-card appearance="outlined">
            <mat-tab-group animationDuration="0ms">
                <mat-tab>
                    <ng-template mat-tab-label>
                        {{ t("support.privacy-policy.tabs.customer-privacy") }}
                    </ng-template>
                    <ng-container>
                        <div class="tab-content-container">
                            <h3>
                                {{
                                    t("support.privacy-policy.tabs.tab1.title")
                                }}
                            </h3>
                            <p
                                [innerHTML]="
                                    t('support.privacy-policy.tabs.tab1.p1')
                                "
                            ></p>
                        </div>
                    </ng-container>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>
</ng-container>
